const AppColors = {
    // Primary colors
    primaryDark: '#211e1e',
    primaryYellow: '#f59220',
    primaryGray: '#E6E8EA',

    // Text colors
    textPrimary: '#211e1e',
    textSecondary: '#666666',
    textWhite: '#FFFFFF',
    textGray: '#999999',

    // Background colors
    backgroundWhite: '#FFFFFF',
    backgroundLightGray: '#F5F5F5',
    backgroundGray: '#E6E8EA',

    // Status colors
    successGreen: '#4CAF50',
    errorRed: '#F44336',
    warningOrange: '#FF9800',
    infoBluе: '#2196F3',

    // Neutral colors
    neutralLight: '#F8F9FA',
    neutralMedium: '#6C757D',
    neutralDark: '#343A40',
};

export default AppColors;
